import Chart from 'components/Chart/Chart'
import DataTable, { Column } from 'components/DataTable/DataTable'
import { useMFContext } from 'components/MFHelpers/MFContext'
import styled from 'styled-components'
import cantonsdata from './cantonsdata.json'
const CantonsMap = () => {
  const { isMobile, _t } = useMFContext()
  const columns: Column[] = [
    {
      key: 'Canton',
      label: _t('canton') as string,
      align: 'left',
      width: isMobile ? '160px' : '240px',
      sortable: true,
    },

    {
      key: 'TotalPotentialProductionGWh',
      label: (
        <>
          {_t('gde_potential')}
          <br />
          <Unit>{_t('inGwh')}</Unit>
        </>
      ),
      align: 'right',
      width: '80px',
      format: (e: number) =>
        (+e.toFixed(1)).toLocaleString('de-CH').replace('.', ','),
      sortable: true,
    },
    {
      key: 'CumEffectivePotentialUsed',
      label: (
        <>
          {_t('gde_usage')}
          <br />
          <Unit>{_t('inPercent')}</Unit>
        </>
      ),
      valuesAsBars: true,
      barColor: 'var(--yellow-main)',
      barMax: 20,
      align: 'left',
      format: (e: number) => (+e.toFixed(1)).toLocaleString('de-CH').replace('.', ','),
      sortable: true,
    },
  ]
  const columnsDesktopOnly: Column[] = [
    {
      key: 'CumTotalProductionGWh',
      label: (
        <>
          {_t('gde_production')}
          <br />
          <Unit>{_t('inGwh')}</Unit>
        </>
      ),
      align: 'right',
      width: '100px',
      sortable: true,
      format: (e: number) =>
        (+e.toFixed(1)).toLocaleString('de-CH').replace('.', ','),
    },
  ]

  return (
    <Chart
      meta={{
        title: _t('cantonstable_title'),
        subtitle: _t('cantonstable_subtitle'),
        source: (
          <>
            {_t('source')}:{' '}
            <a href='https://www.uvek-gis.admin.ch/BFE/storymaps/EE_Elektrizitaetsproduktionsanlagen/'>
              {_t('linechart_source')}
            </a>
          </>
        ),
      }}
      spaceBefore={0}
      spaceAfter={0}
      contentWidth='TextWidthExtendedFullMobile'
    >
      <DataTable
        hideSearch
        data={cantonsdata}
        columns={[...columns, ...(isMobile ? [] : columnsDesktopOnly)]}
        defaultSort={{
          key: 'CumEffectivePotentialUsed',
          direction: 'desc',
        }}
        defaultRowCount={cantonsdata.length}
        alwaysFirst={{ key: 'Canton', value: 'CH' }}
      />
    </Chart>
  )
}
const Unit = styled.span`
  font-size: 12px;
  font-weight: 400;
  /* color: var(--gray-4); */
`
export default CantonsMap
